import React from 'react';

import moment from 'moment';

import {
  AntaiFluxDto,
  GetFluxNextExecutionTimeResponseDtoFluxTypeEnum,
} from 'lib_api/lib/api/gen';

import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { FluxDisplayName } from 'enums/flux/FluxDisplayName';
import useNextExecutionTime from 'hooks/flux/useNextExecutionTime';
import { useDashboardSearchWithSort } from 'hooks/search/useDashboardSearchWithSort';
import { DATE_FORMAT } from 'utils/formats';

import ErrorCell from '../components/ErrorCell/ErrorCell';
import DashboardFlux from '../DashboardFlux';
import { statusIconMapping } from '../utils';

import { FluxAntaiSortOptions } from './types';
import { useSearchFluxAntai } from './utils';

function DashboardEvenementsAntai() {
  const searchFluxAntai = useDashboardSearchWithSort(
    useSearchFluxAntai,
    {},
    { DATE_APPEL: false },
    'paginationFluxAntai',
  );

  const fluxType =
    GetFluxNextExecutionTimeResponseDtoFluxTypeEnum.ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION;
  const nextExecutionTime = useNextExecutionTime(fluxType);

  function buildDetailsContent(data: AntaiFluxDto): React.ReactElement {
    return (
      <ErrorCell
        flux={{
          id: data.id,
          dateAppel: data.dateDebut,
          error: data.error ?? undefined,
          nbWarnings: data.nbWarnings,
        }}
      />
    );
  }

  function buildColumns(): ColumnProps<AntaiFluxDto, FluxAntaiSortOptions>[] {
    return [
      {
        title: '',
        buildCellContent: data => computeBadge(data),
      },
      {
        title: 'Appel',
        buildCellContent: data => moment(data.dateDebut).format(DATE_FORMAT),
        sortedField: FluxAntaiSortOptions.DATE_APPEL,
      },
      {
        title: 'Index de départ',
        buildCellContent: data => data.indexDebut,
        sortedField: FluxAntaiSortOptions.INDEX_DEBUT,
      },
      {
        title: 'Index de fin',
        buildCellContent: data => data.indexFin,
        sortedField: FluxAntaiSortOptions.INDEX_FIN,
      },
      {
        title: "Type d'erreur",
        buildCellContent: data => buildDetailsContent(data),
      },
    ];
  }

  function computeBadge(flux: AntaiFluxDto): React.ReactNode {
    if (flux.error) {
      return statusIconMapping.ERROR;
    } else if (flux.nbWarnings && flux.nbWarnings > 0) {
      return statusIconMapping.WARNING;
    } else {
      return statusIconMapping.SUCCESS;
    }
  }

  return (
    <DashboardFlux
      useSearchFlux={searchFluxAntai}
      buildColumns={buildColumns}
      dateProchaineExecution={nextExecutionTime}
      title={FluxDisplayName.ANTAI}
      buildItemKey={(item: AntaiFluxDto) => item.id}
    />
  );
}

export default DashboardEvenementsAntai;
